import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var NetworkingIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M5.69 7.43c-.42 0-.84-.08-1.23-.24-.39-.16-.75-.4-1.04-.7-.3-.3-.54-.65-.7-1.04-.16-.39-.25-.81-.25-1.23 0-.42.08-.84.25-1.23.16-.39.4-.74.7-1.04.3-.3.65-.54 1.05-.7a3.18 3.18 0 012.46 0c.39.16.74.4 1.04.7.3.3.54.65.7 1.04.16.39.25.81.25 1.23 0 .42-.08.84-.24 1.23-.16.39-.4.75-.7 1.04-.3.3-.65.53-1.04.7-.39.16-.81.25-1.23.25l-.02-.01zm0-4.44c-.16 0-.32.03-.46.09-.15.06-.28.15-.4.27-.11.11-.2.25-.26.39-.06.15-.09.31-.09.47 0 .16.03.32.09.46a1.202 1.202 0 00.67.66 1.246 1.246 0 001.33-.26c.12-.11.2-.25.26-.4.06-.15.09-.3.09-.46 0-.16-.03-.32-.09-.47-.06-.15-.15-.28-.26-.4-.11-.11-.25-.2-.4-.26-.15-.06-.31-.09-.47-.09h-.01zm3.7 10.36c-.55 0-1-.45-1-1 0-.72-.28-1.4-.79-1.91-1.01-1.01-2.8-1.01-3.81 0-.51.51-.79 1.19-.79 1.91 0 .55-.45 1-1 1s-1-.45-1-1c0-1.25.49-2.43 1.38-3.32.89-.89 2.07-1.38 3.32-1.38s2.45.5 3.32 1.38c.89.89 1.38 2.07 1.38 3.32 0 .55-.45 1-1 1h-.01zM19 17.78c-.42 0-.84-.08-1.23-.25-.39-.16-.74-.4-1.04-.7-.3-.3-.54-.65-.7-1.04a3.199 3.199 0 01.69-3.51c1.2-1.2 3.35-1.2 4.55 0 .61.61.94 1.42.94 2.28 0 .42-.08.84-.25 1.23-.16.39-.4.74-.7 1.04-.3.3-.65.54-1.04.7-.39.16-.81.25-1.23.25H19zm0-4.44c-.32 0-.63.13-.86.36a1.22 1.22 0 00-.27 1.33c.06.15.15.28.26.4.11.12.25.2.39.26a1.246 1.246 0 001.33-.26c.12-.11.2-.25.26-.39a1.22 1.22 0 00-.27-1.33 1.22 1.22 0 00-.86-.36l.02-.01zm3.7 10.36c-.55 0-1-.45-1-1 0-.71-.29-1.4-.79-1.91-1.01-1.01-2.8-1.01-3.81 0-.5.5-.79 1.2-.79 1.91 0 .55-.45 1-1 1s-1-.45-1-1c0-1.24.5-2.45 1.38-3.32.88-.87 2.08-1.38 3.32-1.38 1.24 0 2.43.49 3.32 1.38.87.87 1.38 2.08 1.38 3.32 0 .55-.45 1-1 1h-.01zM19 8.91c-.55 0-1-.45-1-1v-.74c0-.52-.2-1.01-.57-1.38-.37-.37-.86-.57-1.38-.57h-2.22c-.55 0-1-.45-1-1s.45-1 1-1h2.22c1.06 0 2.05.41 2.8 1.16s1.16 1.74 1.16 2.8v.74c0 .55-.45 1-1 1L19 8.91zm-8.13 12.57H8.65a3.97 3.97 0 01-3.96-3.96v-.74c0-.55.45-1 1-1s1 .45 1 1v.74c0 1.08.88 1.96 1.96 1.96h2.22c.55 0 1 .45 1 1s-.45 1-1 1z"
                    })
                })
            })
        ]
    });
};
NetworkingIcon.isCarinaIcon = true;
export default NetworkingIcon;
